import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { RegistrationsContext } from '../../context/contextProvider';
import { Registration } from '../../types/registrationTypes';
import { validation } from '../registration-rules';

const RegistrationLocationYup = (showPropertyType: boolean, minDate?: string) => {
  const isDateOutdated = (dateString: string) => {
    const inputDate = new Date(dateString);
    const earliestDate = new Date(minDate ?? '2010-01-01');
    const finalValidDate = new Date();
    return inputDate >= earliestDate && inputDate <= finalValidDate;
  };
  const { t } = useTranslation('registrations');
  const context = useContext(RegistrationsContext);
  const { config } = context;
  const installationConfig = config.installationConfig;
  const yupValidation: yup.SchemaOf<Registration['location']> = yup.object().shape({
    propertyType: yup
      .string()
      .when('showPropertyType', { // showPropertyType does not exist, but need something to hook on to
        is: () => showPropertyType,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.transform(() => undefined).optional()
      })
      .trim()
      .min(validation.propertyType.min)
      .max(validation.propertyType.max),
    installationAddress: yup.string().required().trim().min(validation.address.min).max(validation.address.max).trim(),
    zipCode: yup.string().required().trim().min(validation.zipCode.min).max(validation.zipCode.max).trim(),
    city: yup.string().required().trim().min(validation.city.min).max(validation.city.max).trim(),
    country: yup.string().required().min(validation.country.min).max(validation.country.max),
    installationDate: yup
      .string()
      .matches(validation.dateYYMMDD.regEx, t('registrations.general.invalidDateFormat'))
      .test('date-validation', t('registrations.general.invalidDate'), (value) => isDateOutdated(value ?? ''))
      .required()
  });
  return yupValidation;
};
export default RegistrationLocationYup;
